import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  Link,
  IconButton,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../config";


export default function MatchNumber() {
  const [timer, setTimer] = useState(10);
    const [codes, setCodes] = useState(null);

  const [openPopup, setOpenPopup] = useState(false); // 🔑 new state for popup
  const navigate = useNavigate();
  const { orderId } = useParams();
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
  useEffect(()=>{
fetchCode()

  },[])

  useEffect(() => {
    //fetchCode()
    if (timer > 0) {
      const interval = setInterval(() => setTimer((t) => t - 1), 1000);
      return () => clearInterval(interval);
    } else {
      navigate(`/vendOrder/timeout/${orderId}`, { replace: true });
    }
  }, [timer]);

  const handleClose = () => {
    navigate(`/activeOrder/true/${orderId}`, { replace: true });
  };

  // 🔑 Verify code API
  const handleVerify = async (selectedCode) => {
    try {
      const response = await axios.post(
        //`https://api-prod.daalchini.co.in/consumerbe/api/v1/contactless/verify-code`,
        `${API_BASE_URL}/consumerbe/api/v1/contactless/verify-code`,
        {
          code: selectedCode,
          orderId: orderId,
        },
        {
          headers: {
            Authorization: `Bearer ${UserJWTAuth}`,
            "Content-Type": "application/json",
            "x-app-platform": "web",
            "x-app-version": "v1.0.1",
            "x-device-id": localStorage.getItem("uuid"),
          },
        }
      );

      if (response.data.data.isAuthenticated) {
        navigate(`/vendOrder/success/${orderId}`);
      } else {
        navigate(`/vendOrder/failed/${orderId}`);
      }
    } catch (err) {
     // console.error("Verify error", err);
    }
  };

  // /vendOrder/success/
    const fetchCode = async () => {
      try {
        const response = await axios.get(
          //`https://api-prod.daalchini.co.in/consumerbe/api/v1/contactless/generate-code/${orderId}`,
          `${API_BASE_URL}/consumerbe/api/v1/contactless/generate-code/${orderId}`,
          {
            headers: {
              Authorization: `Bearer ${UserJWTAuth}`,
              "x-app-platform": "web",
              "x-app-version": "v1.0.1",
              "x-device-id": localStorage.getItem("uuid"),
            },
          }
        );
        //console.log("response", response.data.data);
        setCodes(response.data.data.codes);
        //setOrderId(response.data.data.orderId);
      } catch (err) {
        ///console.error("❌ Fetch error", err);
      }
    };

  return (
    <>
    
    <Box
      sx={{
        height: "100vh",
        bgcolor: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
        <Box
          sx={{
            bgcolor: "#fae14b",
            p: 1.5,
            display: "flex",
            alignItems: "center",
                position: "fixed",
      width: "100%"
          }}
        >
        <IconButton size="small" sx={{ mr: 1 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Match The Number
        </Typography>
      </Box>

      {/* Content */}
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          px: 3,
        }}
      >
        <Card
          sx={{
            border: "1px solid #07593E80",
            borderRadius: 2,
            mb: 3,
            width: "80%",
            maxWidth: 320,
            boxShadow: "none",
          }}
        >
          <CardContent sx={{ textAlign: "center", p: 0 }}>
            <Box sx={{ p: 2 }}>
              <Typography
                variant="body1"
                sx={{ color: "red", fontWeight: 600 }}
              >
                {timer} s
              </Typography>
            </Box>
            <Divider sx={{ borderColor: "#07593E80" }} />
            <Box sx={{ p: 2 }}>
              <Grid container spacing={3} justifyContent="center">
                {codes &&
                  codes.map((num, index) => (
                    <Grid item key={index}>
                      <Button
                        variant="outlined"
                        sx={{
                          borderRadius: "50%",
                          width: 56,
                          height: 56,
                          minWidth: 56,
                          borderColor: "#07593E80",
                          color: "#00B177",
                          fontSize: "1.2rem",
                          fontWeight: 600,
                        }}
                        onClick={() => handleVerify(num)}
                      >
                        {num}
                      </Button>
                    </Grid>
                  ))}
              </Grid>
            </Box>
          </CardContent>
        </Card>

        <Typography
       
          variant="body2"
          sx={{ mb: 2, fontSize: "0.95rem", fontWeight: 500 }}
        >
          Tap The Number Shown On The Kiosk
        </Typography>

        <Link
          href="#"
          
          underline="hover"
          textAlign={"center"}
          sx={{
            mb: 2,
            fontSize: "0.9rem",
            fontWeight: 500,
            color: "#09624B",
            textDecoration:"underline"
          }}
           onClick={(e)=>{fetchCode(e)}}
        >
          Didn’t see a number on kiosk?
          <br /> Display again
        </Link>

        <Button
          color="inherit"
          sx={{ textTransform: "none" }}
          onClick={handleClose}
        >
          Cancel
        </Button>
      </Box>

      {/* ⏰ Popup when timer expires */}
      <Dialog open={openPopup} onClose={() => setOpenPopup(false)}>
        <DialogTitle>Time Out</DialogTitle>
        <DialogContent>
          <Typography>Your session has expired. Please try again.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Go Home</Button>
          <Button
            onClick={() => {
              setTimer(15); // reset timer
              setOpenPopup(false);
            }}
          >
            Retry
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
    </>
  );
}
